import { Divider, Group, Stack, Text } from "@mantine/core";
import FoldersListing from "../../lists/ListingWithContent/contacts/FoldersListing";
import FolderAdder from "../../lists/ListingWithContent/contacts/FolderAdder";
import { useListStore } from "../../../../stores/ListStore";
import { useLanguage } from "../../../../stores/LanguageStore";

const ModelFolders = () => {
  const lang = useLanguage((s) => s.language);
  return (
    <Stack pos={"relative"} w={"100%"} mr={16} px={48} h={"calc(100vh - 64px)"}>
      <Group mt={16}>
        <Text size="xl" fw={600}>
          {lang.prospects.my_folders}
        </Text>
        <FolderAdder
          type={"Model"}
          onFinish={() => useListStore.getState().setListingLoad(true)}
          isButton
        />
      </Group>

      <Divider mt={16} />

      <FoldersListing
        type="Model"
        mainUrl="/models"
        keyword="model"
        additional="/type"
      />
    </Stack>
  );
};

export default ModelFolders;
